import { render, staticRenderFns } from "./FilterBlock.vue?vue&type=template&id=01b9ab02&"
import script from "./FilterBlock.vue?vue&type=script&lang=js&"
export * from "./FilterBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports